import { render, staticRenderFns } from "./AssignMemberEquipment.vue?vue&type=template&id=12ed105d&scoped=true"
import script from "./AssignMemberEquipment.vue?vue&type=script&lang=ts"
export * from "./AssignMemberEquipment.vue?vue&type=script&lang=ts"
import style0 from "./AssignMemberEquipment.vue?vue&type=style&index=0&id=12ed105d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed105d",
  null
  
)

export default component.exports